import changePageClass from './_changePageClass';
import {jqDoc} from '../util/jq';

const ignite = window.ignite;

const replaceChoicesBehavior = () => {
  const choicesToReplace = $('.answer-choice');
  choicesToReplace.each(function () {
    const answerChoice = $(this);
    const choiceInputs = answerChoice.find('input');
    answerChoice.find('label').click(function (e) {
      e.preventDefault();
    });
    answerChoice.click(function () {
      $(this).blur();
      choiceInputs.click();
    });
    answerChoice.keyup(function(e) {
      if (e.keyCode === 32) {
        choiceInputs.click();
      }
    });
    choiceInputs.click(function (e) {
      e.stopPropagation();
    });
    choiceInputs.filter('[type=checkbox]').change(function () {
      answerChoice.toggleClass('checked', this.checked);
    });
    choiceInputs.filter('[type=radio]').change(function () {
      $(`input[name="${this.name}"]`).each(function () {
        $(this).closest('.answer-choice').toggleClass('checked', this.checked);
      });
    });
    choiceInputs.each(function () {
      const choiceInput = $(this);
      answerChoice.addClass(choiceInput.attr('type'));
      answerChoice.toggleClass('checked', choiceInput.prop('checked'));
      choiceInput.hide('blind');
    });
  });
};

const customQuestionFunctionality = () => {
  $(jqDoc).ready(function() {
    /* How would you describe your savings plan? */
    $('#continueOnSavingsPathDiv li.answerInput').on('click', function() {
      var fourth = $('.continueOnSavingsPath\\.learnMore');
      if( fourth.hasClass('checked') ) {
        $(this).siblings('li').removeClass('checked');
        $(this).siblings('li').children('.input').children('input:checked').click();
      } else {
        fourth.removeClass('checked');
        fourth.children('.input').children('input:checked').click();
      }
    });
    /* How do you use or plan to use CC? */
    $('#creditCardUsageDiv li.answerInput').on('click', function() {
      var sixth = $('.creditCardUsage\\.learnMore');
      if( sixth.hasClass('checked') ) {
        $(this).siblings('li').removeClass('checked');
        $(this).siblings('li').children('.input').children('input:checked').click();
      } else {
        sixth.removeClass('checked');
        sixth.children('.input').children('input:checked').click();
      }
    });
  });
};

const surveyBanners = () => {
   $(jqDoc).ready(function() {
      let consumerPage;
      let businessPath;
      let businessPage;
      if ( window.location.href.indexOf("consumeranalyzer") > -1) {
         let url = $(location).attr('href'),
         parts = url.split("/"),
         consumerPage = parts[parts.length-2];
         if(consumerPage == "0") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/1.jpg)");
         } else if(consumerPage == "1") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/3.jpg)");
         } else if(consumerPage == "2") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/4.jpg)");
         } else if(consumerPage == "3") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/5.jpg)");
         } else if(consumerPage == "4") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/6.jpg)");
         } else {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/consumer/7.jpg)");
         }
         $(".online-banner").addClass("fade-in");
      } else if ( window.location.href.indexOf("businessanalyzer") > -1) {
         let url = $(location).attr('href'),
         parts = url.split("/"),
         businessPage = parts[parts.length-1]
         businessPath = parts[parts.length-2];
         $(".landing-banner").css("background-image" , "url(/classpath/assets/images/business/1.jpg)");

         if(businessPath == "0" && (businessPage == "0" || businessPage == "8") ) {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/3.jpg)");
         } else if(businessPage == "1" || businessPage == "6" || businessPage == "9") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/4.jpg)");
         } else if(businessPage == "2" || businessPage == "10") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/5.jpg)");
         } else if(businessPage == "3") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/6.jpg)");
         } else if(businessPage == "5") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/8.jpg)");
         } else if(businessPage == "7") {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/2.jpg)");
         } else {
            $(".online-banner").css("background-image" , "url(/classpath/assets/images/business/7.jpg)");
         }

         $(".online-banner").addClass("fade-in");
      }
   })
};

const infoTipAddClass = () => {
  $('#preTaxInvestmentDiv .infoTip, #businessAverageMonthlySavingsBalanceDiv .infoTip').on('click', function() {
    const $surveyBody = $('.survey-html');
    $surveyBody.toggleClass('infoTipModal');
  });
};

export default function surveyPage() {
  changePageClass('survey');
  ignite.autonumberInit();
  ignite.checkboxInit();
  replaceChoicesBehavior();
  customQuestionFunctionality();
  surveyBanners();
  infoTipAddClass();
}



// WEBPACK FOOTER //
// ./src/main/js/pages/surveyPage.js